import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import Select from "commons/ui/input/Select";
import Paper from "commons/ui/Paper";

import MetaFieldsForm from "components/subComponents/MetaFieldsForm";

import usePageForm from "hooks/form/usePageForm";

function PageForm({ pageId }: { pageId?: string }) {
    const { formHook } = usePageForm({ pageId });

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridItem>
            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <Paper>
                        <GridColumn>
                            <GridRow>
                                <GridItem className={"title-margin"}>
                                    <h1>Pagina</h1>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-9"}>
                                    <InputText
                                        label={"Nome"}
                                        setValue={setValue}
                                        value={form.name}
                                        path={"name"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                                <GridItem className={"col-xs-12-3"}>
                                    <Select
                                        label={"Tema"}
                                        setValue={setValue}
                                        options={[
                                            { value: "", label: "" },
                                            { value: "white", label: "Fondo bianco" },
                                            {
                                                value: "transparent",
                                                label: "Fondo trasparente",
                                            },
                                        ]}
                                        value={form.theme}
                                        path={"theme"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>

                            <MetaFieldsForm
                                text={form.text}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridColumn>
                    </Paper>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

export default PageForm;
